import InnerComponent from '@Components/Purchase/PurchaseOrders/BulkPoForm';
import orgContainer from '@Components/AppContainer';

const CreateBulkPo = () => ((orgContainer(InnerComponent)));
export default CreateBulkPo;
